import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import React from 'react'

const DevelopmentalRubricSkeleton = ({ length = 10, lcs = 2, showHeader = true }) => {
  return <>
    {showHeader && (
      <Box className='flex flex-nowrap gap-4 pb-4 items-strech justify-center overflow-auto'>
        {Array.from({ length: 5 }).map((_, jndex) => (
          <Skeleton key={`card-info-${jndex}`} variant="rectangular" width='100%' height={30} className='rounded min-w-100px' />
        ))} 
      </Box>
    )}
    <Box className='py-1 flex flex-col gap-2'>
      {Array.from({ length }).map((_, index) => (
        <div className="flex w-full gap-2" key={`learning-continua-skelenton-${index}`}>
          <Skeleton variant="rectangular" width={220} height={50} className='rounded' />
          {Array.from({ length: lcs }).map((_, jndex) => (
            <Skeleton key={`dr-${index}-lc-${jndex}`} variant="rectangular" width='100%' height={50} className='rounded' />
          ))} 
        </div>
      ))}
    </Box>
  </>;
}

export default DevelopmentalRubricSkeleton